import { FormattedMessage } from 'react-intl';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { ModalBody } from 'ui-components/components/modal/modal-body';

import messages from './messages';
import style from './style.module.less';
import { AddressFields } from '../../../../../../../address/address-fields';
import { EMAIL, PHONE } from '../../../../../../../address/constants';
import { MULTI_LINE_EMAIL_SUB_LABEL, PHONE_NEEDED_FOR_SOME_CARRIERS } from '../../../../../../../address/sublabel-constants';
import { US } from '../../../../../../../constants/country-codes';
import { useAddressValidatorConfig } from '../../../../../../../contexts/country-config-context/use-address-validator-config';
import { ERR, WRN } from '../../../../../../../enums/address-verification-status';
import { useCreateReturnContext } from '../../../../../context/create-return-provider';
import AddressOptionsSection from '../../../../../fulfillment-plan/sections/shipment-details/address/edit-shipto-modal/address-options';
import PasteAddressSection from '../../../../../fulfillment-plan/sections/shipment-details/address/edit-shipto-modal/paste-address-section';

export const Body = () => {
  const { formState, updateForm, validationErrors, updateFormState, resetFormState, isValidatingAddress, validateAddress, isValid } =
    useCreateReturnContext();
  const allowAddressValidation = useAddressValidatorConfig();
  const { countryCode } = formState;
  const showPasteAddress = countryCode === US;

  const subLabels = {
    [PHONE]: PHONE_NEEDED_FOR_SOME_CARRIERS,
    [EMAIL]: MULTI_LINE_EMAIL_SUB_LABEL,
  };

  return (
    <ModalBody>
      {formState.verificationStatus === WRN && <BannerMessageV2 content={formState.verificationMessage} status={BannerStatus.Warning} />}
      {formState.verificationStatus === ERR && (
        <BannerMessageV2
          content={
            <FormattedMessage
              {...messages.verificationBannerErrorMessage}
              values={{ verificationMessage: formState.verificationMessage }}
            />
          }
          status={BannerStatus.Error}
        />
      )}
      <FlexRow className={style['edit-address-modal-body']}>
        <FlexColumn className={style.column}>
          <AddressFields
            address={formState}
            errors={validationErrors}
            line3
            onChange={updateForm}
            showAllErrors
            state
            subLabels={subLabels}
            type='v3'
          />
        </FlexColumn>
        <FlexColumn className={style.column}>
          {showPasteAddress ? <PasteAddressSection resetFormState={resetFormState} updateFormState={updateFormState} /> : null}
          {allowAddressValidation ? (
            <AddressOptionsSection
              formState={formState}
              isValid={isValid}
              isValidatingAddress={isValidatingAddress}
              validateAddress={validateAddress}
            />
          ) : null}
        </FlexColumn>
      </FlexRow>
    </ModalBody>
  );
};
